//th
export const common = {
  "home.awards.title": "รางวัลและเกียรติยศ",
  "home.awards.pause": "หยุดการเลื่อนรางวัลชั่วคราว",
  "home.awards.play": "เล่นการเลื่อนรางวัลต่อ",
  "home.awards.financialAlgorithm": "ผู้นำด้านอัลกอริทึมทางการเงิน",
  "home.awards.asiaPacificGold": "แบรนด์ชั้นนำด้านการซื้อขายทองคำในเอเชียแปซิฟิก",
  "home.awards.preciousMetals": "แบรนด์ซื้อขายโลหะมีค่าที่น่าเชื่อถือ",
  "home.awards.digitalFinance": "องค์กรผู้สนับสนุนนวัตกรรมการเงินดิจิทัล",
  "home.awards.quantitativeTrading": "องค์กรดีเด่นด้านเทคโนโลยีการซื้อขายเชิงปริมาณ",
 'nav.home': 'หน้าแรก',
'nav.trading': 'การเทรด',
'nav.markets': 'ตลาด',
'nav.news': 'ข่าวสาร',
'nav.about': 'เกี่ยวกับเรา',
'nav.contact': 'ติดต่อเรา',
'nav.login': 'เข้าสู่ระบบ',
'nav.register': 'ลงทะเบียน',
'hero.title': 'แพลตฟอร์มการเทรดทองคำและเงินระดับพรีเมียม',
'hero.subtitle': 'บริษัทที่ได้รับใบอนุญาตในฮ่องกง ให้บริการเทรดโลหะมีค่าอย่างปลอดภัยและมืออาชีพสำหรับนักลงทุนยุโรป',
'hero.cta.start': 'เริ่มเทรดเลย',
'hero.cta.learn': 'เรียนรู้เพิ่มเติม',
'home.licenseHK': 'ได้รับใบอนุญาตในฮ่องกง',
'home.bankSec': 'ความปลอดภัยระดับธนาคาร',
'home.247s': 'บริการลูกค้า 24/7',
'home.global': 'มุมมองระดับโลก',
'home.tradingPlat': 'แพลตฟอร์มการเทรด',
'home.tradingWith': 'ระบบที่ทรงพลังและเสถียร',
'home.exp': 'สัมผัสประสบการณ์แพลตฟอร์มเทรดระดับโลกที่ออกแบบมาเฉพาะสำหรับโลหะมีค่า MT5 มาพร้อมเครื่องมือระดับสถาบัน ความเร็วในการดำเนินการสูง และการวิเคราะห์ตลาดครบวงจร',
'home.dlMT5': 'ดาวน์โหลด MT5',
'home.watchDemo': 'ดูวิดีโอตัวอย่าง',
'home.tradingIns': 'ผลิตภัณฑ์การเทรด',
'home.exeSpeed': 'ความเร็วในการดำเนินการ',
'home.mktAccess': 'การเข้าถึงตลาด',
'home.uptime': 'อัตราการออนไลน์',
'home.allDevices': 'รองรับทุกอุปกรณ์',
'home.mktInt': 'ข้อมูลตลาด',
'home.mktInt.desc': 'ติดตามเหตุการณ์เศรษฐกิจและข่าวสารที่มีผลต่อการเทรดโลหะมีค่าแบบเรียลไทม์',
'home.lastUpdate': 'อัปเดตล่าสุด',
'home.ecoCal': 'ปฏิทินเศรษฐกิจ',
'home.refresh': 'รีเฟรช',
'home.currency': 'สกุลเงิน',
'home.events': 'เหตุการณ์',
'home.previous': 'ค่าก่อนหน้า',
'home.forecast': 'คาดการณ์',
'home.actual': 'จริง',
'home.mktNews': 'ข่าวตลาด',
'home.seeMore': 'ดูเพิ่มเติม',
'home.ecoData': 'ข้อมูลเศรษฐกิจจัดทำโดยผู้ให้บริการข้อมูลการเงินหลายแห่ง • ข่าวตลาดจากสื่อการเงินชั้นนำ',
'home.ac': 'ฟีเจอร์กราฟขั้นสูง',
'home.pta': 'การวิเคราะห์ทางเทคนิคระดับมืออาชีพ พร้อมเครื่องมือและอินดิเคเตอร์กว่า 80 ชนิด',
'home.mpa': 'การเข้าถึงหลายแพลตฟอร์ม',
'home.tsa': 'เทรดได้อย่างราบรื่นทั้งบนเดสก์ท็อป เว็บ และมือถือ',
'home.st': 'การเทรดที่ปลอดภัย',
'home.bls': 'เทคโนโลยีเข้ารหัสระดับธนาคาร ปกป้องข้อมูลและการส่งข้อมูลของคุณ',
'home.247': 'เข้าถึงตลาดได้ตลอดเวลา',
'home.rtc': 'เชื่อมต่อกับตลาดโลหะมีค่าทั่วโลกได้ทุกที่ทุกเวลา',
'home.at': 'การเทรดอัตโนมัติ',
'home.ea': 'รองรับระบบเทรดอัตโนมัติ (EA) และกลยุทธ์เชิงอัลกอริทึม',
'home.lfe': 'การดำเนินการความเร็วสูง',
'home.ull': 'ส่งคำสั่งด้วยความหน่วงต่ำมาก สเปรดแข่งขันได้ และจับคู่คำสั่งแบบเรียลไทม์',
'features.title': 'ทำไมต้องเลือกแพลตฟอร์มของเรา',
'features.security.title': 'ความปลอดภัยระดับธนาคาร',
'features.security.desc': 'การเข้ารหัสขั้นสูงและระบบความปลอดภัยหลายชั้นเพื่อปกป้องการลงทุนของคุณ',
'features.licensed.title': 'ได้รับใบอนุญาตอย่างครบถ้วน',
'features.licensed.desc': 'อยู่ภายใต้การกำกับดูแลของฮ่องกง โปร่งใสและเป็นไปตามกฎหมาย',
'features.realtime.title': 'การเทรดแบบเรียลไทม์',
'features.realtime.desc': 'ข้อมูลตลาดแบบเรียลไทม์และการดำเนินการทันที เพื่อคว้าโอกาสที่ดีที่สุด',
'features.support.title': 'บริการลูกค้า 24/7',
'features.support.desc': 'ทีมงานหลายภาษาพร้อมบริการคุณตลอดทั้งปี',
'features.lmd': 'ข้อมูลตลาดแบบเรียลไทม์',
'features.rtp': 'ราคาทองคำและเงินสดทันที',
'markets.title': 'ราคาตลาดแบบเรียลไทม์',
'markets.gold': 'ทองคำ',
'markets.silver': 'เงิน',
'markets.platinum': 'แพลทินัม',
'markets.palladium': 'พาลาเดียม',
'markets.price': 'ราคา',
'markets.change': 'การเปลี่ยนแปลง',
'markets.high': 'ราคาสูงสุด 24 ชม.',
'markets.low': 'ราคาต่ำสุด 24 ชม.',
'markets.contractDetials': 'รายละเอียดสัญญา',
'markets.contractDetials.desc': 'ข้อมูลสเปกและเงื่อนไขการเทรดโลหะมีค่าแบบครบถ้วน',
'markets.tradingExample': 'ตัวอย่างการเทรด',
'markets.goldExample': 'ตัวอย่างการเทรดทองคำ',
'markets.silverExample': 'ตัวอย่างการเทรดเงิน',
'markets.instrument': 'ผลิตภัณฑ์',
'markets.lotSize': 'ขนาดล็อต',
'markets.entPrice': 'ราคาเข้า',
'markets.marReq': 'มาร์จิ้นที่ต้องใช้',
'markets.pip': 'มูลค่าต่อจุด',
'markets.pmt': 'การเทรดโลหะมีค่า',
'markets.ctt': 'ทำความเข้าใจเงื่อนไขและสเปกของการเทรดโลหะมีค่า มาร์จิ้น และการบริหารความเสี่ยง เพื่อสนับสนุนการลงทุนทองคำและเงิน',
'markets.vts': 'ดูสเปกการเทรด',
'markets.dcd': 'ดาวน์โหลดรายละเอียดสัญญา',
'markets.ec': 'ความเร็วในการดำเนินการ',
'markets.th': 'เวลาการเทรด',
'markets.ms': 'สเปรดต่ำสุด (pips)',
'markets.ml': 'เลเวอเรจสูงสุด',
'markets.mr': 'ข้อกำหนดมาร์จิ้น',
'markets.lo': 'ตัวเลือกเลเวอเรจและมาร์จิ้นตามประเภทบัญชี',
'markets.leverage': 'เลเวอเรจ',
'markets.margin': 'มาร์จิ้น',
'markets.mind': 'เงินฝากขั้นต่ำ',
'markets.mc': 'เครื่องคิดเลขมาร์จิ้น',
'markets.gmc': 'คำนวณมาร์จิ้นทองคำ',
'markets.cp': 'ราคาปัจจุบัน',
'markets.cv': 'มูลค่าสัญญา',
'markets.smc': 'คำนวณมาร์จิ้นเงิน',
'markets.rm': 'การบริหารความเสี่ยง',
'markets.crm': 'ปกป้องการลงทุนของคุณด้วยเครื่องมือและกลยุทธ์ที่ครอบคลุม',
'markets.rtg': 'แนวทางการยอมรับความเสี่ยง',
'markets.rd': 'การเปิดเผยความเสี่ยง',
'markets.tpm': 'การเทรดโลหะมีค่าอาจมีความเสี่ยงสูงและไม่เหมาะกับนักลงทุนทุกคน ผลการดำเนินงานที่ผ่านมาไม่ได้บ่งชี้ถึงผลลัพธ์ในอนาคต',
'markets.lcw': 'เลเวอเรจสามารถสร้างกำไรหรือขาดทุนได้มากขึ้น โปรดพิจารณาเป้าหมาย ประสบการณ์ และระดับความเสี่ยงของคุณอย่างรอบคอบก่อนตัดสินใจเทรด',
'markets.ysb': 'โปรดทำความเข้าใจความเสี่ยงทั้งหมดที่เกี่ยวข้องกับการเทรดโลหะมีค่า หากมีข้อสงสัย ควรปรึกษาที่ปรึกษาทางการเงินอิสระ',
'markets.rfr': 'อ่านการเปิดเผยความเสี่ยงฉบับเต็ม',
'markets.cra': 'ติดต่อที่ปรึกษาความเสี่ยง',
'markets.tho': 'เวลาการเทรด',
'markets.moh': 'ตารางการทำงานและวันหยุดของตลาดโลหะมีค่า',
'markets.wts': 'ตารางเวลาการเทรดประจำสัปดาห์',
'markets.note': 'หมายเหตุ',
'markets.atad': 'เวลาทั้งหมดแสดงเป็น GMT+8 การเทรดอาจหยุดชั่วคราวในช่วงวันหยุดหลักหรือความผันผวนสูง',
'markets.hs': 'ตารางวันหยุด',
'markets.mclo': 'ตลาดปิด',
'markets.eclo': 'ปิดก่อนเวลา',
'markets.hn': 'ประกาศวันหยุด',
'markets.thm': 'ในช่วงวันหยุดราชการ เวลาการเทรดอาจมีการเปลี่ยนแปลง โปรดติดตามประกาศของเรา',
'markets.cms': 'สถานะตลาดปัจจุบัน',
'markets.mac': 'ตลาดเปิดทำการ',
'markets.st': 'เวลาเซิร์ฟเวอร์ (GMT+8)',
'markets.ts': 'สเปกการเทรด',
'markets.dtc': 'เงื่อนไขและสเปกการเทรดทองคำและเงินโดยละเอียด',
'markets.msp': 'สเปรดต่ำสุด',
'markets.minls': 'ล็อตขั้นต่ำ',
'markets.maxls': 'ล็อตสูงสุด',
'markets.commission': 'ค่าคอมมิชชัน',
'markets.sls': 'ดอกเบี้ยข้ามคืน (Long/Short)',
'markets.in': 'หมายเหตุสำคัญ',
'markets.smv': 'ในช่วงที่ตลาดมีความผันผวนสูงหรือมีข่าวสำคัญ สเปรดอาจขยายตัว',
'markets.sra': 'ดอกเบี้ยข้ามคืนจะอัปเดตรายวันและอาจเปลี่ยนแปลงตามสภาวะตลาด',
'markets.mlm': 'ในช่วงข่าวใหญ่ เลเวอเรจสูงสุดอาจถูกปรับลดลง',
'markets.ata': 'เวลาทั้งหมดแสดงเป็น GMT+8',

'news.title': 'ข่าวสารและการวิเคราะห์ตลาดล่าสุด',
'news.subtitle': 'ติดตามมุมมองผู้เชี่ยวชาญและความเคลื่อนไหวของตลาด',
'news.readMore': 'อ่านเพิ่มเติม',
'news.category.analysis': 'การวิเคราะห์ตลาด',
'news.category.news': 'ข่าวด่วน',
'news.category.insights': 'มุมมองผู้เชี่ยวชาญ',
'news.category.education': 'การศึกษา',
'news.date': 'วันที่เผยแพร่',
'news.author': 'ผู้เขียน',
'home.partners.title': 'พันธมิตรของเรา',
'home.partners.subtitle': 'เราร่วมมือกับผู้ให้บริการชั้นนำระดับโลกด้านสภาพคล่อง ฟินเทค และโครงสร้างพื้นฐานการซื้อขาย',
'testimonials.title': 'ได้รับความไว้วางใจจากนักลงทุนทั่วโลก',
'testimonials.client1.name': 'Marcus Weber',
'testimonials.client1.location': 'เยอรมนี • แฟรงก์เฟิร์ต',
'testimonials.client1.text': 'แพลตฟอร์มมีราคาเสนอโปร่งใส การดำเนินการเชื่อถือได้ ระบบรักษาความปลอดภัยทำให้มั่นใจมากขึ้น',
'testimonials.client2.name': 'Sophie Dubois',
'testimonials.client2.location': 'ฝรั่งเศส • ปารีส',
'testimonials.client2.text': 'บริการระดับมืออาชีพ สเปรดแข่งขันได้ และทีมซัพพอร์ตหลายภาษาช่วยได้มากจริง ๆ',
'testimonials.client3.name': 'Alessandro Rossi',
'testimonials.client3.location': 'อิตาลี • มิลาน',
'testimonials.client3.text': 'การดำเนินการรวดเร็ว เครื่องมือวิเคราะห์ยอดเยี่ยม เหมาะสำหรับผู้ที่จริงจังกับการเทรดโลหะมีค่า',
'footer.company': 'บริษัท',
'footer.trading': 'การเทรด',
'footer.support': 'การสนับสนุน',
'footer.legal': 'กฎหมาย',
'footer.about': 'เกี่ยวกับเรา',
'footer.careers': 'ร่วมงานกับเรา',
'footer.news': 'ข่าวสาร',
'footer.platforms': 'แพลตฟอร์มการเทรด',
'footer.education': 'การศึกษา',
'footer.analysis': 'การวิเคราะห์ตลาด',
'footer.help': 'ศูนย์ช่วยเหลือ',
'footer.contact': 'ติดต่อเรา',
'footer.faq': 'คำถามที่พบบ่อย',
'footer.terms': 'ข้อกำหนดการให้บริการ',
'footer.privacy': 'นโยบายความเป็นส่วนตัว',
'footer.risk': 'การเปิดเผยความเสี่ยง',
'footer.copyright': '© 2024 GOLD Label Global Limited. สงวนลิขสิทธิ์ทั้งหมด',
'footer.license': "บริษัทที่จัดตั้งขึ้นในฮ่องกง",
'footer.riskwarning': 'คำเตือนความเสี่ยง',
'footer.disclaimer': 'การเทรดมาร์จิ้นเป็นผลิตภัณฑ์ทางการเงินแบบมีเลเวอเรจ ซึ่งอาจทำให้เกิดการขาดทุนมากกว่าจำนวนเงินฝากของคุณ คุณไม่ได้เป็นเจ้าของหรือถือครองสินทรัพย์อ้างอิงใด ๆ โปรดอ่าน “คำแถลงการเปิดเผยความเสี่ยง” ของบริษัทอย่างละเอียดก่อนทำการเทรด โปรดทำความเข้าใจความเสี่ยงที่เกี่ยวข้องทั้งหมด และบริหารความเสี่ยงอย่างระมัดระวัง บริษัทจะไม่รับผิดชอบต่อผลที่เกิดจากการกระทำหรือการงดเว้นใด ๆ อันเกิดจากการอ้างอิงเนื้อหาในเว็บไซต์นี้',
'footer.jurisdiction': "ประกาศเกี่ยวกับเขตอำนาจศาล",
'footer.jurisdictionDisclaimer': "บริการตามที่อธิบายบนเว็บไซต์นี้ให้บริการเฉพาะแก่ลูกค้าที่มีคุณสมบัติเหมาะสมในเขตอำนาจศาลนอกฮ่องกงและสหรัฐอเมริกา ทั้งนี้เฉพาะในกรณีที่กฎหมายที่ใช้บังคับในเขตอำนาจศาลของลูกค้าอนุญาตให้ให้บริการดังกล่าว บริการจะไม่ให้แก่ผู้มีถิ่นพำนักในฮ่องกงหรือสหรัฐอเมริกา หรือบุคคลในเขตอำนาจศาลที่การให้บริการดังกล่าวผิดกฎหมายหรือถูกห้าม เว็บไซต์นี้ไม่ได้มุ่งเน้นไปยังบุคคลในเขตอำนาจศาลที่ถูกจำกัด และไม่ถือเป็นการเสนอ การชักชวน หรือคำแนะนำแก่บุคคลดังกล่าว",
'footer.relatedEntity': 'นิติบุคคลที่เกี่ยวข้องอื่น',
'footer.saintLuciaEntity': 'Gold Label Global (SL) Limited เป็นบริษัทธุรกิจระหว่างประเทศที่จัดตั้งขึ้นในประเทศเซนต์ลูเซียเมื่อวันที่ 4 กันยายน 2026 เลขทะเบียนบริษัท 2026-00680 สำนักงานจดทะเบียน: Ground Floor, The Sotheby Building, Rodney Village, Rodney Bay, Gros-Islet, Saint Lucia สำนักงานจดทะเบียนนี้จัดไว้เพื่อการปฏิบัติตามข้อกำหนดทางกฎหมายและกฎระเบียบเท่านั้น มิใช่สถานประกอบธุรกิจจริงของบริษัท และไม่ได้ใช้สำหรับการดำเนินงาน การเข้าพบของลูกค้า หรือการติดต่อทางจดหมาย',
'footer.regNo': 'หมายเลขทะเบียนบริษัท',
'common.language': 'ภาษา',
'common.loading': 'กำลังโหลด…',
'common.error': 'เกิดข้อผิดพลาด',
'common.success': 'สำเร็จ',
'common.close': 'ปิด',
'common.save': 'บันทึก',
'common.cancel': 'ยกเลิก',
'common.continue': 'ดำเนินการต่อ',
'common.back': 'ย้อนกลับ',
'common.next': 'ถัดไป',
'common.previous': 'หน้าก่อนหน้า',
'common.submit': 'ส่ง',
'common.reset': 'รีเซ็ต',
'about.yearsOfExp': 'ประสบการณ์หลายปี',
'about.yearsOfExp.desc': 'สั่งสมความเชี่ยวชาญในตลาดโลหะมีค่ามาหลายทศวรรษ',
'about.dailyTrade': 'ปริมาณการเทรดต่อวัน',
'about.dailyTrade.desc': 'การซื้อขายทองคำและเงินในฮ่องกงมีมูลค่ากว่า 80,000 ล้าน HKD ต่อวัน',
'about.satClients': 'ความพึงพอใจของลูกค้า',
'about.satClients.desc': 'ให้บริการลูกค้าและสถาบันทั่วโลก',
'about.exeSpeed': 'ความเร็วในการดำเนินการ',
'about.exeSpeed.desc': 'เทคโนโลยีการเทรดความเร็วสูงระดับสายฟ้าแลบ',
'about.ourAch': 'ความสำเร็จของเรา',
'about.ourAch.desc': 'ได้รับการยอมรับด้วยผลงานที่เป็นผู้นำในอุตสาหกรรม',
'about.companyProfile': 'ข้อมูลบริษัท',
'about.about1': 'เกี่ยวกับ Gold Label Global',
'about.about2': 'Gold Label Global Limited เป็นบริษัทจำกัดที่ได้รับอนุญาตจากรัฐบาลฮ่องกง และเป็นสมาชิกของ Chinese Gold & Silver Exchange Society การซื้อขายทองคำและเงินในฮ่องกงมีมูลค่ารวมราว 80,000 ล้าน HKD ต่อวัน ถือเป็นผู้นำระดับโลกด้านประสบการณ์การเทรด',
'about.about3': 'ทีมผู้บริหารของ Gold Label Global มีประสบการณ์ด้านการเทรดทองคำและเงินกว่า 20 ปี ให้บริการลูกค้าและสถาบันนับไม่ถ้วน โดยมูลค่าการเทรดรวมหลายหมื่นล้าน ได้รับการยอมรับอย่างสูงจากลูกค้าและผู้เชี่ยวชาญในอุตสาหกรรม',
'about.about4': 'เรามุ่งมั่นที่จะมอบสภาพแวดล้อมการเทรดที่รวดเร็ว เสถียร และมีคุณภาพสูงสุด ด้วยระบบเทรดระดับสากลและทีมเทคนิคชั้นนำ เพื่อพัฒนาโซลูชันที่ทรงพลังและครอบคลุมยิ่งขึ้น ทำให้การเทรดรวดเร็วและมีประสิทธิภาพมากกว่าเดิม',
'about.about5': 'Gold Label Global จะเติบโตไปพร้อมกับคุณ แบ่งปันความสำเร็จและความมั่งคั่งร่วมกัน',
'about.about6': 'สำรวจเส้นทางการเติบโตของเราในตลาดโลหะมีค่า และความมุ่งมั่นของเราต่อความเป็นเลิศในตลาดการเงินโลก',
'about.about7': 'ในฐานะบริษัทที่ได้รับอนุญาตจากรัฐบาลฮ่องกงและเป็นสมาชิกของ Chinese Gold & Silver Exchange Society เราจัดการการซื้อขายทองคำและเงินมูลค่ากว่า 80,000 ล้าน HKD ต่อวัน พร้อมประสบการณ์การเทรดระดับแนวหน้า',
'about.proTeam': 'ทีมผู้เชี่ยวชาญ',
'about.proTeam.desc': 'ทีมบริหารมีประสบการณ์ด้านทองคำและเงินมากกว่า 20 ปี ให้บริการลูกค้าและสถาบันมากมาย',
'about.proService': 'บริการระดับมืออาชีพ',
'about.proService.desc': 'ทีมบริการลูกค้าพร้อมให้บริการตลอด 24 ชั่วโมง ทั้งทางออนไลน์และมือถือ พร้อมคำแนะนำเฉพาะสำหรับลูกค้าแต่ละราย',
'about.sec': 'ความปลอดภัยมาก่อน',
'about.sec.desc': 'ไม่มีความเสี่ยงจากคู่สัญญา ออเดอร์ถูกส่งตรงเข้าสู่ตลาด โปร่งใสและปลอดภัย',
'about.strict': 'การกำกับดูแลอย่างเข้มงวด',
'about.strict.desc': 'Gold Label Global เป็นสถาบันการค้าฮ่องกงที่อยู่ภายใต้การกำกับดูแลของรัฐบาลฮ่องกง และเป็นสมาชิกของสมาคมการค้าฮ่องกง',
'about.fastDes': 'ฝากเงินรวดเร็ว',
'about.fastDes.desc': 'บริการตลอด 24 ชั่วโมง ฝากเงินภายในไม่กี่วินาที พร้อมใช้งานทันที',
'about.productSafe': 'ผลิตภัณฑ์ที่ปลอดภัย',
'about.productSafe.desc': 'ครอบคลุมผลิตภัณฑ์โลหะมีค่าหลักทั่วโลก ปลอดภัยและเชื่อถือได้',
'about.whyGLB': 'ทำไมต้องเลือก Gold Label Global',
'about.whyGLB.desc': 'ค้นหาความได้เปรียบสำคัญที่ทำให้เราเป็นตัวเลือกอันดับหนึ่งในตลาดโลหะมีค่า',
'about.readyToStart': 'พร้อมเริ่มต้นการเทรดหรือยัง?',
'about.join': 'เข้าร่วมกับลูกค้าหลายพันรายทั่วโลกที่ไว้วางใจ GOLD Label Global เพื่อความต้องการเทรดโลหะมีค่าของคุณ',
'about.openTradingAcc': 'เปิดบัญชีเทรด',
'about.contactTeam': 'ติดต่อทีมงานของเรา',
'about.co': 'ความร่วมมือเพื่อความสำเร็จร่วมกัน',
'about.co.desc': 'สร้างความสัมพันธ์ระยะยาวที่เป็นประโยชน์ร่วมกันกับลูกค้าและพันธมิตร',
'about.safety': 'ความปลอดภัย',
'about.safety.desc': 'รับรองว่าการเทรดทั้งหมดเป็นไปตามมาตรฐานความปลอดภัยสูงสุด',
'about.integrity': 'ความซื่อสัตย์',
'about.integrity.desc': 'ยึดมั่นในมาตรฐานความโปร่งใสและจรรยาบรรณสูงสุด',
'about.professional': 'ความเป็นมืออาชีพ',
'about.professional.desc': 'มอบบริการที่โดดเด่นด้วยความเชี่ยวชาญที่เหนือชั้น',
'about.fast': 'รวดเร็ว',
'about.fast.desc': 'ให้บริการที่ตอบสนองอย่างรวดเร็วและดำเนินการฉับไว',
'about.coreValue': 'ค่านิยมหลักของเรา',
'about.coreValue.desc': 'แนวทางหลักที่นำพาเราไปสู่ความเป็นเลิศในตลาดโลหะมีค่า',
'contact.sendUsMsg': 'ส่งข้อความถึงเรา',
'contact.fillOut': 'โปรดกรอกแบบฟอร์มด้านล่าง ทีมงานของเราจะตอบกลับภายใน 24 ชั่วโมง',
'contact.inqType': 'ประเภทการสอบถาม',
'contact.genInq': 'สอบถามทั่วไป',
'contact.accSup': 'ฝ่ายสนับสนุนบัญชี',
'contact.traSup': 'ฝ่ายสนับสนุนการเทรด',
'contact.techSup': 'ฝ่ายสนับสนุนด้านเทคนิค',
'contact.partner': 'พาร์ทเนอร์',
'contact.fullname': 'ชื่อ–นามสกุล *',
'contact.email': 'อีเมล *',
'contact.phone': 'เบอร์โทรศัพท์',
'contact.subject': 'หัวเรื่อง *',
'contact.msg': 'ข้อความ *',
'contact.sendMsg': 'ส่งข้อความ',
'contact.whyUs': 'ทำไมต้องเลือกเรา?',
'contact.regSec': 'ได้รับการกำกับดูแลและปลอดภัย',
'contact.licAndReg': 'สภาพแวดล้อมการเทรดที่ถูกกำกับดูแลและปลอดภัย พร้อมมาตรการรักษาความปลอดภัยขั้นสูงเพื่อคุ้มครองการลงทุนของคุณ',
'contact.expSup': 'ผู้เชี่ยวชาญคอยช่วยเหลือ',
'contact.proService': 'เจ้าหน้าที่การเทรดระดับมืออาชีพพร้อมช่วยคุณ 24/7 สำหรับทุกความต้องการและคำถาม',
'contact.fastExe': 'การดำเนินการรวดเร็ว',
'contact.lightFast': 'ส่งคำสั่งความเร็วระดับสายฟ้า พร้อมสลิปเพจน้อยมาก เพื่อประสิทธิภาพสูงสุด',
'contact.glbNet': 'ตลาดทั่วโลก',
'contact.asscessToint': 'เชื่อมต่อกับตลาดโลหะมีค่านานาชาติ สเปรดแข่งขันได้ และสภาพคล่องเชิงลึก',
'contact.followUs': 'ติดตามโซเชียลมีเดียของเรา:',
'contact.contactOutPro': 'หากต้องการความช่วยเหลือด้านการเทรด การเปิดบัญชี หรือสอบถามทั่วไป โปรดติดต่อทีมผู้เชี่ยวชาญของเรา:',
'contact.officeAddress': 'ที่ตั้งสำนักงาน',
'contact.bussHour': 'เวลาทำการ: จันทร์–ศุกร์ 9:00–18:00 (GMT+8)',
'contact.phoneSupp': 'การสนับสนุนทางโทรศัพท์',
'contact.mainOffice': 'สำนักงานใหญ่',
'contact.availableServices': 'บริการที่มีให้:',
'contact.accOpenSup': 'ช่วยเหลือการเปิดบัญชี',
'contact.tradSup': 'ความช่วยเหลือแพลตฟอร์มเทรด',
'contact.genSup': 'การสนับสนุนทั่วไป',
'contact.emailSup': 'การสนับสนุนทางอีเมล',
'contact.responseTime': 'ระยะเวลาการตอบกลับ:',
'contact.genInq24': 'สอบถามทั่วไป: ภายใน 24 ชั่วโมง',
'contact.techSup24': 'สนับสนุนด้านเทคนิค: ภายใน 4 ชั่วโมง',
'contact.accIss24': 'ปัญหาบัญชี: ภายใน 2 ชั่วโมง',
'contact.needImSup': 'ต้องการความช่วยเหลือด่วน?',
'contact.needImSup.desc': 'เจ้าหน้าที่การเทรดของเราพร้อม 24/7 สำหรับกรณีเร่งด่วนและการสนับสนุนบัญชี',
'contact.callNow': 'โทรตอนนี้',
'contact.sendEmail': 'ส่งอีเมล',
'contact.contactUs': 'ติดต่อเรา',
'contact.getInTouch': 'ติดต่อทีมเทรดมืออาชีพของเรา เรามุ่งมั่นช่วยให้คุณประสบความสำเร็จในการเทรดโลหะมีค่า',
'contact.247Sup': 'บริการลูกค้า 24/7',
'contact.247Sup.desc': 'ดูแลทุกความต้องการด้านการเทรดของคุณตลอดเวลา',
'contact.dirLine': 'สายด่วนโดยตรง',
'contact.dirLine.desc': 'พูดคุยกับเจ้าหน้าที่การเทรดของเราโดยตรง',
'contact.hkOffice': 'สำนักงานฮ่องกง',
'contact.hkOffice.desc': 'ตั้งอยู่ใจกลางย่านการเงินของฮ่องกง',

'platform.wco': 'ทำไมต้องเลือกแพลตฟอร์ม MT5 ของเรา?',
'platform.etd': 'สัมผัสประสบการณ์ยอดเยี่ยมจากแพลตฟอร์มขั้นสูงที่ออกแบบเพื่อเทรดเดอร์มืออาชีพ',
'platform.rts': 'พร้อมเริ่มเทรดแล้วหรือยัง?',
'platform.jto': 'เทรดเดอร์นับหมื่นไว้วางใจแพลตฟอร์มของเราในการเทรดโลหะมีค่า',
'platform.ola': 'เปิดบัญชีจริง',
'platform.tda': 'ทดลองบัญชีเดโม',
'platform.dmt': 'ดาวน์โหลดแพลตฟอร์ม MT5',
'platform.ayt': 'ลงชื่อเข้าใช้และจัดการบัญชีของคุณได้บนทุกอุปกรณ์ผ่านแอป MT5',
'platform.free': 'ฟรี',
'platform.dn': 'ดาวน์โหลดทันที',
'platform.sr': 'สเปกระบบ',
'platform.nh': 'ต้องการความช่วยเหลือเริ่มต้นใช้งาน?',
'platform.os': 'ทีมสนับสนุนของเราพร้อมช่วยคุณตั้งค่าและเริ่มเทรดได้ทุกเมื่อ',
'platform.ug': 'คู่มือการใช้งาน',
'platform.cs': 'ติดต่อฝ่ายสนับสนุน',
'platform.si': 'ต้องการการเชื่อมต่ออินเทอร์เน็ตที่เสถียร',
'platform.ptf': 'ฟังก์ชันการเทรดอันทรงพลัง',
'platform.epg': 'เครื่องมือระดับมืออาชีพ ออกแบบมาสำหรับทั้งผู้เริ่มต้นและมือโปร',
'platform.ac': 'กราฟขั้นสูง',
'platform.pct': 'เครื่องมือกราฟระดับโปร พร้อมอินดิเคเตอร์กว่า 80 ตัวและหลายกรอบเวลา เพื่อการวิเคราะห์ตลาดอย่างรอบด้านครบถ้วน',
'platform.lfe': 'ดำเนินการระดับสายฟ้า',
'platform.ull': 'ความหน่วงต่ำเป็นพิเศษ ดำเนินการไวสุด 0.01 วินาที ช่วยให้เข้า–ออกออเดอร์อย่างแม่นยำ',
'platform.ea': 'เทรดอัตโนมัติ (EA)',
'platform.atc': 'รองรับ EA แบบกำหนดเองและกลยุทธ์เชิงอัลกอริทึม',
'platform.rm': 'การบริหารความเสี่ยง',
'platform.crm': 'มีเครื่องมือครบถ้วน เช่น Stop Loss, Take Profit และการควบคุมขนาดสถานะ',
'platform.mpa': 'เข้าถึงได้หลายแพลตฟอร์ม',
'platform.tsa': 'เทรดได้อย่างไร้รอยต่อบนเดสก์ท็อป เว็บ และมือถือ พร้อมซิงก์บัญชี',
'platform.gm': 'ตลาดทั่วโลก',
'platform.ati': 'เข้าถึงตลาดนานาชาติรวมถึงโลหะมีค่า ฟอเร็กซ์ ดัชนี และสินค้าโภคภัณฑ์',
'platform.etw': 'สัมผัสแพลตฟอร์มการเทรดที่ล้ำหน้าที่สุดของโลก ใช้เทคโนโลยีระดับสถาบันและการดำเนินการความเร็วสูงสำหรับโลหะมีค่า ฟอเร็กซ์ และสัญญา CFD',
'platform.download': 'ดาวน์โหลด ',
'platform.wd': 'ดูตัวอย่าง',
'platform.es': 'ความเร็วในการดำเนินการ',
'platform.th': 'เวลาการเทรด',
'platform.in': 'ผลิตภัณฑ์ที่เทรดได้',
'platform.lt': 'การเทรดจริง',
'platform.ptt': 'เครื่องมือการเทรดระดับมืออาชีพ',
'platform.aig': 'มอบเครื่องมือระดับสถาบันสำหรับเทรดเดอร์มืออาชีพและนักลงทุนสายพิถีพิถัน',
'platform.rtd': 'ข้อมูลเรียลไทม์',
'platform.lmd': 'ข้อมูลตลาดและการอัปเดตราคาแบบเรียลไทม์',
'platform.pa': 'การแจ้งเตือนราคา',
'platform.caf': 'กำหนดแจ้งเตือนความผันผวนของราคาและเหตุการณ์ตลาดได้เอง',
'platform.this': 'ประวัติการเทรด',
'platform.cth': 'ประวัติการเทรดและการวิเคราะห์ผลงานอย่างครบถ้วน',
'platform.ec': 'ปฏิทินเศรษฐกิจ',
'platform.suw': 'ติดตามเหตุการณ์เศรษฐกิจสำคัญแบบใกล้ชิด',
'platform.mw': 'ราคาตลาด',
'platform.rtp': 'ราคาสดและ Market Depth สำหรับทุกสินค้าที่เทรดได้',
'platform.om': 'การจัดการคำสั่ง',
'platform.aot': 'รองรับคำสั่งขั้นสูง เช่น Market, Limit, Stop และ Trailing Stop',
'platform.ta': 'วิเคราะห์ทางเทคนิค',
'platform.cta': 'ชุดเครื่องมือวิเคราะห์ทางเทคนิคครบครัน พร้อมอินดิเคเตอร์และเครื่องมือวาดที่ปรับแต่งได้',
'platform.ufe': 'การดำเนินการความเร็วสูงพิเศษ',
'platform.rtc': 'ทีมผู้เชี่ยวชาญด้านการเทรดและเทคโนโลยีพร้อมดูแลคุณตลอด 24 ชั่วโมง',
'platform.247a': 'ให้บริการตลอด 24 ชั่วโมง',
'platform.csp' : 'สเปรดที่แข่งขันได้',
'platform.iia': 'สเปรดชั้นนำของอุตสาหกรรมและราคาที่โปร่งใส ไม่มีค่าธรรมเนียมหรือคอมมิชชันแอบแฝง',
'platform.01pip': 'เริ่มต้นที่ 0.1 pip',
'platform.ffd': '[translate:แอปพลิเคชันเดสก์ท็อปแบบครบฟังก์ชันสำหรับ Windows 10/11]',
'platform.nma': '[translate:แอปพลิเคชัน macOS แบบเนทีฟที่มีฟังก์ชันครบถ้วน]',
'platform.mta': '[translate:แอปเทรดมือถือสำหรับอุปกรณ์ Android]',
'platform.iai': '[translate:แอปเทรดสำหรับ iPhone และ iPad]',

'faq.tagline': '[translate:เราสามารถช่วยคุณได้อย่างไร?]',
'faq.title': '[translate:เราสามารถช่วยคุณได้อย่างไร?]',
'faq.subtitle': '[translate:เรียกดูคำถามที่พบบ่อย (FAQ) เพื่อค้นหาคำตอบอย่างรวดเร็วสำหรับข้อสงสัยของคุณ]',
'faq.categories': '[translate:หมวดหมู่]',
'faq.cantFind': '[translate:ไม่พบสิ่งที่คุณกำลังมองหาหรือ?]',
'faq.supportText': '[translate:ทีมสนับสนุนของเราพร้อมช่วยเหลือหากคำถามของคุณไม่ได้อยู่ในรายการ FAQ.]',
'faq.contactSupport': '[translate:ติดต่อทีมสนับสนุน]',

'faq.general': '[translate:ทั่วไป]',
'faq.account': '[translate:บัญชี]',
'faq.trading': '[translate:การเทรด]',
'faq.platform': '[translate:แพลตฟอร์ม]',
'faq.deposits': '[translate:การฝากและถอนเงิน]',
'faq.security': '[translate:ความปลอดภัย]',

'faq.general.q1': '[translate:GOLD LABEL GLOBAL LIMITED คืออะไร?]',
'faq.general.a1': '[translate:GOLD LABEL GLOBAL LIMITED เป็นบริษัทเทรดโลหะมีค่าที่ได้รับการกำกับดูแลในฮ่องกง ให้บริการเทรดทองคำ เงิน และโลหะมีค่าอื่น ๆ ผ่านแพลตฟอร์ม MT5.]',
'faq.general.q2': '[translate:บริษัทมีผลิตภัณฑ์เทรดอะไรบ้าง?]',
'faq.general.a2': '[translate:เรามีโลหะมีค่าหลากหลายประเภท เช่น ทองคำสปอต (XAU/USD), เงินสปอต (XAG/USD), แพลทินัม, พัลลาเดียม และสัญญาซื้อขายล่วงหน้า.]',
'faq.general.q3': '[translate:ชั่วโมงการเทรดคือช่วงใด?]',
'faq.general.a3': '[translate:ตลาดโลหะมีค่าเปิดตลอด 24 ชั่วโมง วันจันทร์ถึงศุกร์ ตั้งแต่วันอาทิตย์เวลา 17:00 น. EST ถึงวันศุกร์เวลา 16:00 น. EST.]',
'faq.general.q4': '[translate:การลงทุนกับบริษัทปลอดภัยหรือไม่?]',
'faq.general.a4': '[translate:ปลอดภัยแน่นอน เราได้รับใบอนุญาตและอยู่ภายใต้การกำกับดูแลอย่างเคร่งครัด เงินของลูกค้าถูกเก็บไว้ในบัญชีธนาคารที่ปลอดภัยและแยกจากบัญชีบริษัท รวมถึงมีการประกันครอบคลุมเพิ่มเติม.]',

'faq.account.q1': '[translate:จะเปิดบัญชีเทรดได้อย่างไร?]',
'faq.account.a1': '[translate:คุณสามารถเปิดบัญชีออนไลน์โดยกรอกแบบฟอร์ม สมัครและส่งเอกสารยืนยันตัวตน พร้อมฝากเงินครั้งแรก ใช้เวลาโดยทั่วไป 1–2 วันทำการ.]',
'faq.account.q2': '[translate:เงินฝากขั้นต่ำเท่าไร?]',
'faq.account.a2': '[translate:บัญชีมาตรฐานต้องฝากขั้นต่ำ 1,000 ดอลลาร์สหรัฐ เรามีบัญชีพรีเมียมพร้อมสิทธิพิเศษเพิ่มเติม.]',
'faq.account.q3': '[translate:สามารถมีหลายบัญชีได้หรือไม่?]',
'faq.account.a3': '[translate:ได้ คุณสามารถเปิดหลายบัญชีที่มีสกุลเงินฐานหรือประเภทบัญชีต่างกัน เพื่อใช้กลยุทธ์การเทรดที่แตกต่างกัน.]',
'faq.account.q4': '[translate:ต้องยืนยันบัญชีอย่างไร?]',
'faq.account.a4': '[translate:ต้องใช้บัตรประจำตัวที่ออกโดยรัฐบาล (หนังสือเดินทางหรือใบขับขี่) และหลักฐานที่อยู่ (เช่น ใบแจ้งหนี้ค่าสาธารณูปโภคหรือใบแจ้งยอดธนาคาร) ภายใน 3 เดือนล่าสุด.]',

'faq.trading.q1': '[translate:ขนาดการเทรดขั้นต่ำคือเท่าไร?]',
'faq.trading.a1': '[translate:ขนาดการเทรดขั้นต่ำคือ 0.01 ล็อต สำหรับสินค้าส่วนใหญ่ เพื่อให้การบริหารความเสี่ยงมีความยืดหยุ่น.]',
'faq.trading.q2': '[translate:บริษัทมีเลเวอเรจเท่าไร?]',
'faq.trading.a2': '[translate:เรามีเลเวอเรจสูงสุดถึง 1:100 สำหรับการเทรดโลหะมีค่าโดยมีการบริหารความเสี่ยงอย่างมีความรับผิดชอบ.]',
'faq.trading.q3': '[translate:มีค่าธรรมเนียมการเทรดไหม?]',
'faq.trading.a3': '[translate:เราใช้โครงสร้างค่าสเปรดโดยไม่มีค่าคอมมิชชั่นเพิ่มเติม สเปรดมีความโปร่งใสและแข่งขันได้.]',
'faq.trading.q4': '[translate:สามารถใช้ระบบเทรดอัตโนมัติได้หรือไม่?]',
'faq.trading.a4': '[translate:ได้ แพลตฟอร์ม MT5 รองรับ Expert Advisors (EA) และกลยุทธ์เทรดอัตโนมัติอย่างเต็มรูปแบบ.]',

'faq.platform.q1': '[translate:รองรับแพลตฟอร์มการเทรดใดบ้าง?]',
'faq.platform.a1': '[translate:เรารองรับ MetaTrader 5 (MT5) ซึ่งเป็นแพลตฟอร์มเทรดชั้นนำของอุตสาหกรรม ใช้งานได้ทั้งบนคอมพิวเตอร์ (Windows/Mac), มือถือ (iOS/Android) และเว็บเบราว์เซอร์.]',
'faq.platform.q2': '[translate:MT5 ใช้งานได้ฟรีหรือไม่?]',
'faq.platform.a2': '[translate:ฟรีอย่างสมบูรณ์ คุณสามารถดาวน์โหลดและใช้ทุกฟีเจอร์ได้โดยไม่มีค่าใช้จ่ายเพิ่มเติม.]',
'faq.platform.q3': '[translate:สามารถเทรดบนมือถือได้หรือไม่?]',
'faq.platform.a3': '[translate:แน่นอน แอป MT5 บนมือถือมีฟังก์ชันครบถ้วน ทั้งกราฟแบบเรียลไทม์ ข่าวตลาด และการจัดการบัญชี.]',
'faq.platform.q4': '[translate:มีบัญชีเดโมหรือไม่?]',
'faq.platform.a4': '[translate:มี เรามีบัญชีเดโมพร้อมเงินเสมือนให้คุณฝึกเทรดก่อนลงทุนจริง.]',

'faq.deposits.q1': '[translate:มีวิธีการฝากเงินอะไรบ้าง?]',
'faq.deposits.a1': '[translate:เรารับการฝากผ่านการโอนเงินผ่านธนาคาร บัตรเครดิต/เดบิต (Visa, MasterCard) และช่องทางการชำระเงินออนไลน์ต่าง ๆ อย่างปลอดภัย.]',
'faq.deposits.q2': '[translate:การฝากใช้เวลานานแค่ไหน?]',
'faq.deposits.a2': '[translate:การฝากด้วยบัตรเครดิตจะดำเนินการทันที ส่วนการโอนผ่านธนาคารใช้เวลา 1–3 วันทำการ การชำระผ่านระบบออนไลน์มักจะใช้เวลาไม่กี่ชั่วโมง.]',
'faq.deposits.q3': '[translate:มีค่าธรรมเนียมในการฝากหรือไม่?]',
'faq.deposits.a3': '[translate:เราไม่คิดค่าธรรมเนียมในการฝากส่วนใหญ่ แต่ธนาคารหรือผู้ให้บริการชำระเงินของคุณอาจมีค่าบริการเพิ่มเติม.]',
'faq.deposits.q4': '[translate:จะถอนเงินได้อย่างไร?]',
'faq.deposits.a4': '[translate:คุณสามารถส่งคำขอถอนเงินผ่านพอร์ทัลลูกค้า โดยเงินจะถูกโอนไปยังวิธีที่คุณใช้ฝากเงิน และเวลาในการประมวลผลจะแตกต่างกันตามวิธีที่เลือก.]',

'faq.security.q1': '[translate:ข้อมูลส่วนบุคคลของฉันปลอดภัยแค่ไหน?]',
'faq.security.a1': '[translate:เราปกป้องข้อมูลทั้งหมดด้วยการเข้ารหัส SSL 256 บิต ข้อมูลของคุณจะถูกเก็บไว้อย่างปลอดภัยและไม่ถูกเปิดเผยกับบุคคลที่สามเว้นแต่ได้รับอนุญาต.]',
'faq.security.q2': '[translate:มีระบบยืนยันตัวตนสองขั้นตอน (2FA) หรือไม่?]',
'faq.security.a2': '[translate:มี และเราแนะนำให้เปิดใช้เพื่อเพิ่มระดับความปลอดภัยของบัญชี.]',
'faq.security.q3': '[translate:ถ้าฉันลืมรหัสผ่านต้องทำอย่างไร?]',
'faq.security.a3': '[translate:คุณสามารถกดลิงก์ “ลืมรหัสผ่าน” ที่หน้าเข้าสู่ระบบ และจะได้รับลิงก์รีเซ็ตผ่านอีเมลเพื่อสร้างรหัสผ่านใหม่.]',
'faq.security.q4': '[translate:บริษัทรับประกันความเป็นธรรมของการเทรดอย่างไร?]',
'faq.security.a4': '[translate:เรามีระบบราคาตลาดแบบเรียลไทม์ ไม่มีการแทรกแซงจากดีลเลอร์ และปฏิบัติตามข้อกำหนดทางกฎหมายอย่างเข้มงวดเพื่อให้มั่นใจในความโปร่งใสและเป็นธรรม.]',

'hero.browseFAQ': '[translate:ดูคำถามที่พบบ่อย]',
'hero.contactSupport': '[translate:ติดต่อฝ่ายสนับสนุน]',

'contactCTA.phoneTitle': '[translate:บริการทางโทรศัพท์]',
'contactCTA.phoneDesc': '[translate:พูดคุยกับผู้เชี่ยวชาญโดยตรง]',
'contactCTA.callNow': '[translate:โทรเลย]',
'contactCTA.emailTitle': '[translate:บริการทางอีเมล]',
'contactCTA.emailDesc': '[translate:รับคำตอบโดยละเอียดทางอีเมล]',
'contactCTA.sendMsg': '[translate:ส่งข้อความ]',
'contactCTA.chatTitle': '[translate:แชทสด]',
'contactCTA.chatDesc': '[translate:บริการตอบแชททันที]',
'contactCTA.available': '[translate:ให้บริการตลอด 24 ชั่วโมง]',
'contactCTA.startChat': '[translate:เริ่มการแชท]',
'contactCTA.title': '[translate:ยังต้องการความช่วยเหลือเพิ่มเติมหรือไม่?]',
'contactCTA.subtitle': '[translate:ทีมสนับสนุนของเราพร้อมให้บริการคุณตลอด 24 ชั่วโมงทุกวัน.]',
'markets.specsTitle': 'กฎการซื้อขายโลหะมีค่าและฟอเร็กซ์',
'markets.specsDisclaimer': '* เงื่อนไขการซื้อขายอาจเปลี่ยนแปลงตามการตั้งค่าแพลตฟอร์มและสภาพคล่องของตลาด',
'markets.spreadTypeFloating': 'สเปรดลอยตัว',
'markets.points': 'จุด',
'markets.variableByMarket': 'ขึ้นอยู่กับสภาวะตลาด',

'markets.table.symbol': 'สัญลักษณ์',
'markets.table.contractUnit': 'ขนาดสัญญา',
'markets.table.minLot': 'ล็อตขั้นต่ำ',
'markets.table.maxLot': 'ล็อตสูงสุด',
'markets.table.leverage': 'เลเวอเรจ',
'markets.table.spreadType': 'ประเภทสเปรด',
'markets.table.avgSpread': 'สเปรดเฉลี่ย',
'markets.table.swapLong': 'สวอปฝั่งซื้อ',
'markets.table.swapShort': 'สวอปฝั่งขาย',
'markets.contractSections.contractSize.title': 'ขนาดสัญญา',
'markets.contractSections.contractSize.items.xauusd.label': 'ทองคำ (XAUUSD)',
'markets.contractSections.contractSize.items.xauusd.desc': 'ขนาดสัญญามาตรฐานสำหรับการซื้อขายทองคำ',
'markets.contractSections.contractSize.items.xagusd.label': 'เงิน (XAGUSD)',
'markets.contractSections.contractSize.items.xagusd.desc': 'ขนาดสัญญามาตรฐานสำหรับการซื้อขายเงิน',
'markets.contractSections.contractSize.items.gaucnh.label': 'GAUCNH',
'markets.contractSections.contractSize.items.gaucnh.desc': 'ขนาดสัญญามาตรฐานสำหรับการซื้อขาย FX ที่เกี่ยวข้องกับ RMB นอกประเทศ',

'markets.contractSections.priceMove.title': 'การเคลื่อนไหวราคาขั้นต่ำ',
'markets.contractSections.priceMove.items.goldTick.label': 'ขนาด Tick ของทองคำ',
'markets.contractSections.priceMove.items.goldTick.desc': 'หน่วยการเปลี่ยนแปลงราคาขั้นต่ำ',
'markets.contractSections.priceMove.items.silverTick.label': 'ขนาด Tick ของเงิน',
'markets.contractSections.priceMove.items.silverTick.desc': 'หน่วยการเปลี่ยนแปลงราคาขั้นต่ำ',
'markets.contractSections.priceMove.items.fxTick.label': 'ขนาด Tick ของ FX',
'markets.contractSections.priceMove.items.fxTick.desc': 'หน่วยการเปลี่ยนแปลงราคาขั้นต่ำของคู่สกุลเงิน',

'markets.contractSections.settlement.title': 'วิธีการชำระราคา',
'markets.contractSections.settlement.items.type.label': 'ประเภทการชำระราคา',
'markets.contractSections.settlement.items.type.value': 'ชำระด้วยเงินสด',
'markets.contractSections.settlement.items.type.desc': 'ไม่จำเป็นต้องส่งมอบสินทรัพย์จริง',
'markets.contractSections.settlement.items.currency.label': 'สกุลเงินที่ใช้ชำระ',
'markets.contractSections.settlement.items.currency.desc': 'สินค้าโลหะมีค่าชำระเป็นดอลลาร์สหรัฐ',
'markets.contractSections.settlement.items.fxQuote.label': 'สกุลเงินอ้างอิง',
'markets.contractSections.settlement.items.fxQuote.desc': 'GAUCNH แสดงราคาเทียบกับ CNH',

'markets.contractSections.positionLimits.title': 'ข้อจำกัดของสถานะ',
'markets.contractSections.positionLimits.items.maxPosition.label': 'สถานะสูงสุด',
'markets.contractSections.positionLimits.items.maxPosition.desc': 'ต่อหนึ่งสินค้าในแต่ละบัญชี',
'markets.contractSections.positionLimits.items.orderDistance.label': 'ระยะห่างคำสั่ง',
'markets.contractSections.positionLimits.items.orderDistance.desc': 'ระยะห่างขั้นต่ำจากราคาตลาด',
'markets.contractSections.positionLimits.items.execution.label': 'โหมดการดำเนินคำสั่ง',
'markets.contractSections.positionLimits.items.execution.value': 'ดำเนินคำสั่งตามราคาตลาด',
'markets.contractSections.positionLimits.items.execution.desc': 'คำสั่งจะถูกดำเนินการตามสภาพคล่องของตลาด',

'markets.days.monday': 'วันจันทร์',
'markets.days.tuesday': 'วันอังคาร',
'markets.days.wednesday': 'วันพุธ',
'markets.days.thursday': 'วันพฤหัสบดี',
'markets.days.friday': 'วันศุกร์',
'markets.days.saturday': 'วันเสาร์',
'markets.days.sunday': 'วันอาทิตย์',

'markets.hours.monThu': '06:00 - 04:59',
'markets.hours.friday': '06:00 - 04:57',
'markets.hours.closed': 'ปิดตลาด',

'markets.holidays.newYear.date': '1 มกราคม',
'markets.holidays.newYear.event': 'วันขึ้นปีใหม่',
'markets.holidays.christmas.date': '25 ธันวาคม',
'markets.holidays.christmas.event': 'วันคริสต์มาส',
'markets.holidays.independence.date': '4 กรกฎาคม',
'markets.holidays.independence.event': 'วันชาติสหรัฐฯ',
'markets.holidays.thanksgiving.date': '24 พฤศจิกายน',
'markets.holidays.thanksgiving.event': 'วันขอบคุณพระเจ้า',
  "hero.cta.accountOpening": "ขั้นตอนการเปิดบัญชี",
  "hero.cta.depositWithdraw": "ขั้นตอนการฝากและถอนเงิน",
  "androidDownload.title": "ดาวน์โหลด MetaTrader 5",
  "androidDownload.description": "ระบบจะพาคุณไปยัง Google Play โดยอัตโนมัติ หากอุปกรณ์ของคุณไม่สามารถใช้ Google Play ได้ คุณสามารถดาวน์โหลด APK ได้โดยตรง",
  "androidDownload.autoRedirect": "จะไปยัง Google Play ใน {{seconds}} วินาที",
  "androidDownload.openGooglePlay": "เปิด Google Play",
  "androidDownload.downloadApk": "ดาวน์โหลด APK โดยตรง",
  "androidDownload.hint": "หาก Google Play ไม่เปิด โปรดแตะ “ดาวน์โหลด APK โดยตรง”",
  'windowsDownload.pageTitle': 'ดาวน์โหลด Windows MT5',
  'windowsDownload.pageDesc': 'โปรดเลือกเวอร์ชันติดตั้งที่เหมาะกับคุณ',
  'windowsDownload.badge': 'ดาวน์โหลด Windows MT5',
  'windowsDownload.title': 'เลือกแพ็กเกจติดตั้งของคุณ',
  'windowsDownload.description': 'โปรดเลือกแพ็กเกจติดตั้ง Windows MT5 เวอร์ชัน Gold Label Smooth Stable แนะนำสำหรับผู้ใช้จีนแผ่นดินใหญ่และฮ่องกง และสามารถเลือกตัวติดตั้งอย่างเป็นทางการได้เช่นกัน',
  'windowsDownload.smoothTitle': '1. Gold Label Smooth Stable Version',
  'windowsDownload.smoothDesc': 'แนะนำสำหรับผู้ใช้ Windows ในจีนแผ่นดินใหญ่ / ฮ่องกง ผู้ใช้ในภูมิภาคอื่นสามารถใช้ได้หากตัวติดตั้งอย่างเป็นทางการไม่สะดวก',
  'windowsDownload.smoothButton': 'ดาวน์โหลด Gold Label Smooth Stable Version',
  'windowsDownload.officialTitle': '2. ตัวติดตั้งทางการของ MetaQuotes',
  'windowsDownload.officialDesc': 'ลิงก์ดาวน์โหลดเดิม ผู้ใช้ Windows ในจีนแผ่นดินใหญ่อาจพบปัญหาการติดตั้งเป็นครั้งคราว ส่วนผู้ใช้ในภูมิภาคอื่นไม่ได้รับผลกระทบ',
  'windowsDownload.officialButton': 'ดาวน์โหลดตัวติดตั้งทางการ',

  // Economic calendar explorer
  'calendar.hongKongTime': 'เวลาฮ่องกง (GMT+8)',
  'calendar.previousDays': '7 วันก่อนหน้า',
  'calendar.nextDays': '7 วันถัดไป',
  'calendar.today': 'วันนี้',
  'calendar.jumpToDate': 'ไปยังวันที่',
  'calendar.completeView': 'มุมมองทั้งหมด',
  'calendar.allDays': 'ครบ 7 วัน',
  'calendar.events': 'เหตุการณ์',
  'calendar.impactAll': 'ผลกระทบทั้งหมด',
  'calendar.impactHigh': 'สูง',
  'calendar.impactMedium': 'ปานกลาง',
  'calendar.impactLow': 'ต่ำ',
  'calendar.searchPlaceholder': 'ค้นหาเหตุการณ์ ประเทศ หรือสกุลเงิน',
  'calendar.eventsFound': 'เหตุการณ์ที่แสดง',
  'calendar.lastUpdated': 'อัปเดตล่าสุด',
  'calendar.loadError': 'ไม่สามารถโหลดปฏิทินเศรษฐกิจได้ชั่วคราว',
  'calendar.noEvents': 'ไม่พบเหตุการณ์เศรษฐกิจที่ตรงกับมุมมองนี้',
  'calendar.tryAnotherDate': 'เลือกวันที่อื่นหรือล้างตัวกรอง',
  'calendar.time': 'เวลา',
  'calendar.impact': 'ผลกระทบ',
  'calendar.released': 'ประกาศแล้ว',
  'calendar.pending': 'รอประกาศ',
  'calendar.disclaimer': 'เวลาในปฏิทินเป็นเวลาฮ่องกง ตัวเลขอาจมีการแก้ไขและมีไว้เพื่อข้อมูลเท่านั้น',
  'news.tab.newsDesc': 'ข่าวตลาดล่าสุด บทวิเคราะห์ทองคำ และเนื้อหาให้ความรู้',
  'news.tab.calendarDesc': 'ดูเหตุการณ์เศรษฐกิจสำคัญและข้อมูลประกาศในวันใกล้เคียง',
  'news.autoRefresh': 'ข้อมูลข่าวจะรีเฟรชโดยอัตโนมัติ',

  'news.tabs.news': 'ข่าว',
  'news.tabs.calendar': 'ปฏิทินเศรษฐกิจ',

};

export default common;
